import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../../constants/svgIcon';
import { Space } from '../../../../models/SpaceStore';
import { WebBoosterType } from '../../../../models/UserStore';
import {
  AppBar,
  ClubViewCard,
  ScrollArrows,
  SvgIcon,
} from '../../../Molecules';

import styles from './ClubListTemplate.module.css';
import Masonry from 'react-masonry-css';

type Props = {
  spaces: Space[];
  title: string;
  webBoosterType: WebBoosterType | undefined;
  onClickClub: (classroomId: string) => void;
  onClickRecentAlbum: () => void;
};

export const ClubListTemplate = (props: Props) => {
  const { title, spaces, webBoosterType, onClickClub, onClickRecentAlbum } =
    props;
  const { t } = useTranslation();

  // Breakpoints for responsive masonry layout
  const breakpointColumnsConfig = {
    default: 3, // 3 columns on large screens
    768: 2, // 2 columns on tablets
    // 360: 1, // 1 column on small screens
  };

  return (
    <div className={styles.container}>
      {spaces.length > 10 && <ScrollArrows />}
      {/* 57px is header height */}
      <AppBar title={t(title)} withBack={true} />

      <div className={styles.whiteBarContainer}>
        <div className={styles.whiteBar} onClick={onClickRecentAlbum}>
          <div className={styles.iconContainer}>
            <SvgIcon
              name={SVGIconType.RecentArrow}
              width={28}
              height={28}
              color={'#333'}
            />
          </div>
          <div className={styles.whiteBarText}>{t('Recently Played')}</div>
          <div className={styles.whiteBarArrow}>
            <SvgIcon
              name={SVGIconType.Arrow}
              width={20}
              height={20}
              color="#808080"
            />
          </div>
        </div>
      </div>

      <Masonry
        breakpointCols={breakpointColumnsConfig}
        className={`${styles.masonryGrid}`} // Styled grid container
        columnClassName={`${styles.masonryColumn}`} // Styled column
      >
        {spaces.map((space, index) => (
          <ClubViewCard
            key={index}
            space={space}
            webBoosterType={webBoosterType}
            onClick={() => onClickClub(space.classroomId)}
          />
        ))}
      </Masonry>
    </div>
  );
};
